<script>
    import { faWarning } from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";


</script>

<div class="warning">
    <div class="icon">
        <Fa
            icon={faWarning}
        />
    </div>
    <div class="message">
        <slot></slot>
    </div>
</div>

<style>
    .warning {
        background-color: rgba(255, 228, 140, 0.2);
        color: saddlebrown;
        border: 1px solid rgb(255, 228, 140);
        border-radius: 0.5rem;
        display: flex;
        align-items: center;
        padding: 0.5rem 1rem;
        gap: 1rem;
        margin: 1rem 0;
    }
</style>
